export default "__VITE_ASSET__DT5Z8ja1__"